import { useEffect, useState } from "react";

// components
import { CustomerStatusTag } from "shared/components/customers/misc/customer-status-tag";
import {
    Card,
    CardContent, CardFooter,
    CardFooterItem, CardFooterLinkItem
} from "shared/components/bulma/card";

// functions
import { titleCasePipe } from "shared/pipes";
import { EmployeeController } from "controllers";
import { Ellipsis } from "shared/pipes/ellipsis";
import { ClipboardCopy } from "shared/pipes/clipboard-copy";

const Tags = ({ customer, fields = [] }) => (
    <div className="field is-grouped is-grouped-multiline">
        {fields.map((field) => (
            <div key={field} className="control">
                <div className="tags has-addons">
                    <span className="tag is-primary">{titleCasePipe.transform(field)}</span>
                    <span className="tag is-light">{customer[field] || 'N/A'}</span>
                </div>
            </div>
        ))}
    </div>
);

const Icon = ({ icon }) => (
    <span className="icon">
        <i className={`fas fa-${icon}`}></i>
    </span>
);

const CurrentStylist = ({ customer }) => {
    const [stylist, setStylist] = useState('Not assigned');

    useEffect(() => {
        const getStylist = async () => {
            if (!customer.current_stylist) {
                return;
            }

            const s = await EmployeeController.getEmployee(customer.current_stylist);
            if (s) {
                setStylist(`${s.first_name} ${s.last_name}`);
            }
        }

        getStylist();
    });

    return (
        <div className="tags has-addons">
            <span className="tag is-primary">Current Stylist</span>
            <span className="tag is-light">{stylist}</span>
        </div>
    )
}

const CustomerCard = ({ customer }) => (
    <Card>
        <CardFooter >
            <CardFooterItem className="columns" path={`/closet-hackers/${customer.id}`}>
                <div className="column is-auto is-offset-1" >

                    <ClipboardCopy value={customer.id} tooltip={null}>
                        <Ellipsis maxChars="15">
                            {customer.full_name || 'Name Missing'}
                        </Ellipsis>
                    </ClipboardCopy>
                </div>
                <div className="column is-3">

                    <CustomerStatusTag customer={customer} />
                </div>

            </CardFooterItem>
        </CardFooter>

        <CardContent>
            <Tags customer={customer} fields={['email']}></Tags>
            <Tags customer={customer} fields={['distribution_partner', 'delivery_week']}></Tags>
            <Tags customer={customer} fields={['shirt_size', 'denim_size']}></Tags>
            <CurrentStylist customer={customer} />
        </CardContent>

        <CardFooter>
            <CardFooterLinkItem path={`/closet-hackers/${customer.id}`}>
                <Icon icon="edit" />
            </CardFooterLinkItem>
            <CardFooterLinkItem className="has-text-success" path={`/closet-hackers/${customer.id}?tab=Boxes`}>
                <Icon icon="box" />
            </CardFooterLinkItem>
            <CardFooterLinkItem className="has-text-warning" path={`/closet-hackers/${customer.id}?tab=Comments`}>
                <Icon icon="comment" />
            </CardFooterLinkItem>
            <CardFooterLinkItem className="has-text-info" path={`/closet-hackers/${customer.id}/style`}>
                <Icon icon="vest-patches" />
            </CardFooterLinkItem>
            <CardFooterLinkItem className="has-text-dark" path={`/closet-hackers/${customer.id}?tab=Settings`}>
                <Icon icon="gear" />
            </CardFooterLinkItem>
        </CardFooter>
    </Card >
);

export { CustomerCard };
